export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  // Fork: esconde as abas "Todos" e "Não atribuídas", deixando só "Minhas".
  'conversation_only_mine',
  // Fork: libera apagar mensagem já enviada (issue #49).
  'message_delete',
];

export const CONVERSATION_ONLY_MINE_PERMISSION = 'conversation_only_mine';
export const MESSAGE_DELETE_PERMISSION = 'message_delete';

// Permissões de módulos do AstraChat (controle de visibilidade por função).
export const KANBAN_MODULE_PERMISSIONS = [
  'kanban_module',
  'projects_module',
  'appointments_module',
  'disparador_module',
  'email_module',
  'internal_chat_module',
  'flows_module',
  'sequences_module',
  'connections_module',
  'crm_reports_module',
  'calls_module',
  'synapse_module',
];

// CRUD granular por módulo (item 5). Cada módulo tem "Ver" (o `*_module` acima) e,
// quando `crud: true`, também Criar/Editar/Excluir (`<key>_create/update/delete`).
// Módulos só-visualização (Relatórios CRM, Ligações, Synapse) ficam só com "Ver".
export const MODULE_CRUD_ACTIONS = ['create', 'update', 'delete'];

export const KANBAN_MODULES_MATRIX = [
  { key: 'kanban', crud: true },
  { key: 'projects', crud: true },
  { key: 'appointments', crud: true },
  { key: 'disparador', crud: true },
  { key: 'email', crud: true },
  { key: 'internal_chat', crud: true },
  { key: 'flows', crud: true },
  { key: 'sequences', crud: true },
  { key: 'connections', crud: true },
  { key: 'crm_reports', crud: false },
  { key: 'calls', crud: false },
  { key: 'synapse', crud: false },
];

// permissão de um módulo+ação. read → o `<key>_module` legado (visibilidade).
export const modulePermission = (key, action) =>
  action === 'read' ? `${key}_module` : `${key}_${action}`;

// lista plana de todas as permissões CRUD de escrita (espelha MODULE_CRUD_PERMISSIONS do model)
export const MODULE_CRUD_PERMISSIONS = KANBAN_MODULES_MATRIX.filter(
  m => m.crud
).flatMap(m => MODULE_CRUD_ACTIONS.map(a => `${m.key}_${a}`));

// Permissões de CHAMADAS — SEPARADAS por provedor. Cada uma só aparece no editor
// de função se o módulo correspondente estiver habilitado (mapa abaixo).
// wavoip_calls_receive fica de fora: a integração Wavoip foi removida no
// 60504f52f e o merge com o fornecedor a reintroduziria.
export const CALL_PERMISSIONS = [
  'astracall_calls_receive',
  'whatsapp_360_calls_receive',
];

// permissão de chamada → módulo (feature_modules) que a habilita/exibe
export const CALL_PERMISSION_MODULE_BY_KEY = {
  astracall_calls_receive: 'astracall',
  whatsapp_360_calls_receive: 'whatsapp_360_calls',
};

// Mapa moduleKey (feature_modules) → permissão de função
export const KANBAN_MODULE_PERMISSION_BY_KEY = {
  astracall: 'astracall_calls_receive',
  whatsapp_360_calls: 'whatsapp_360_calls_receive',
  kanban: 'kanban_module',
  projects: 'projects_module',
  appointments: 'appointments_module',
  disparador: 'disparador_module',
  email: 'email_module',
  internal_chat: 'internal_chat_module',
  flows: 'flows_module',
  sequences: 'sequences_module',
  connections: 'connections_module',
  crm_reports: 'crm_reports_module',
  calls: 'calls_module',
  synapse: 'synapse_module',
};

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
